import Store from "@/store";
import {addMinutes, format} from "date-fns";

export default class GenexUtils {
  static setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  static makeStorageSizeHumanReadable(bytes, si = false, dp = 1) {
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
      return bytes + " B";
    }
    const units = si
        ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
        : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
    let u = -1;
    const r = 10 ** dp;

    do {
      bytes /= thresh;
      ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
    return bytes.toFixed(dp) + " " + units[u];
  }

  static async getAuthDetailsAndSaveThem() {

    const result = await Store.dispatch("auth/getUser", {
      success: async () => {
        const { state } = Store;
        if (state.user.roles.some(e => e.name === "guardian")) {
          await Promise.all([Store.dispatch("guardian/setGuardian"), Store.dispatch("guardian/getLearners")]);
        } else {
          await Store.dispatch("guardian/setLearner");
        }
        state.requestedHandshake = true;
      }
    });

    return result
  }

  // Function to convert minutes to HH:mm format
  static convertMinutesToTimeFormat(inputMinutes) {
    const totalMinutes = parseInt(inputMinutes, 10);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    // Format the time as HH:MM
    return `${this.padZero(hours)}:${this.padZero(minutes)}`;
  }

  static padZero(num) {
    return num < 10 ? '0' + num : num;
  }
}
